import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { generateRoutePath } from 'epic-common/src/route';
import Swiper from 'swiper';
import SwiperButton from '../../swiperButton/SwiperButton';
import Callout from '../../callout/Callout';
import Swoosh from '../../swoosh/Swoosh';
import ShardParticles from '../../shardParticles/ShardParticles';
import SquareButton from '../../squareButton/SquareButton';

const CharacterBlock = ({block, handlePrev, handleNext, active}) => {
    const swiperContainer = useRef();
    const prevBtn = useRef();
    const nextBtn = useRef();
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        new Swiper(swiperContainer.current, {
            loop: true,
            navigation: {
              prevEl: prevBtn.current,
              nextEl: nextBtn.current
            },
            on: {
                slideChange: function() { //eslint-disable-line
                    setCurrentSlide(this.realIndex);
                }
            },
            speed: 500
        });
    }, [])

    return (
        <div className="home--character-block home-section-block">
            <ShardParticles amount={30} active={active} />
            <Swoosh active={active} />
            <div className="overlay" />
            <SwiperButton onClick={handlePrev} inverted />
            <div className="home-section-block-content">
                <div className={classNames('swiper-container', active ? 'active' : '')} ref={swiperContainer}>
                    <div className="swiper-wrapper">
                        {
                            block.characters.map((character, index) => (
                                <div className="character-wrapper swiper-slide" key={character.name}>
                                    <img
                                        src={character.bgImage}
                                        alt={character.name} />
                                    <Callout
                                        headline={character.name}
                                        description={character.description}
                                        buttonText={block.buttonText}
                                        buttonLink={`${generateRoutePath('characters')}#${character.name}`}
                                        align="left"
                                        active={active && currentSlide === index}
                                    />
                                </div>
                            ))
                        }
                    </div>
                    <div className="navigation-btns">
                        <span ref={prevBtn}><SquareButton config={{arrow: 'left'}} /></span>
                        <span ref={nextBtn}><SquareButton config={{arrow: 'right'}} /></span>
                    </div>
                </div>
            </div>
            <SwiperButton onClick={handleNext} />
        </div>
    )
};

CharacterBlock.propTypes = {
    block: PropTypes.object,
    handlePrev: PropTypes.func,
    handleNext: PropTypes.func,
    active: PropTypes.bool
};

CharacterBlock.defaultProps = {
    block: {},
    handlePrev: fn => fn,
    handleNext: fn => fn,
    active: false
};

export default CharacterBlock;
